import { MenuItem, TextField } from '@mui/material';
import { userTypes } from '../../resources/constants';
import { Props } from './interface';

const UserTypeSelect = ({ value, onChange, allOption, required, margin = 'normal', sx }: Props) => {
  return (
    <TextField
      fullWidth
      select
      label='Тип користувача'
      margin={margin}
      required={required}
      value={value}
      onChange={onChange}
      sx={sx}
    >
      {allOption && <MenuItem value=''>Усі</MenuItem>}
      {userTypes.map(type => (
        <MenuItem key={type.value} value={type.value}>
          {type.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default UserTypeSelect;
